import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector:
    '[role="button"], [role="tab"], [role="menuitem"], [role="link"], [tabindex], [ngbDropdownToggle], [data-toggle="dropdown"]'
})
export class KeyboardActivationDirective {
  constructor(private el: ElementRef<HTMLElement>) {}

  @HostListener('keydown', ['$event'])
  handleKeydown(event: KeyboardEvent) {
    const key = event.key;
    if (key !== 'Enter' && key !== ' ' && key !== 'Spacebar') {
      return;
    }

    const target = this.el.nativeElement;
    if (
      target.hasAttribute('disabled') ||
      target.getAttribute('aria-disabled') === 'true'
    ) {
      return;
    }

    const tagName = target.tagName.toLowerCase();
    const isNativeInteractive = ['button', 'input', 'select', 'textarea'].includes(tagName);
    const isAnchor = tagName === 'a';
    const hasDropdownToggle =
      target.hasAttribute('ngbDropdownToggle') ||
      target.hasAttribute('ngbdropdowntoggle') ||
      target.getAttribute('data-toggle') === 'dropdown';

    if (key === 'Enter') {
      if (!isNativeInteractive && (!isAnchor || hasDropdownToggle)) {
        event.preventDefault();
        target.click();
      }
      return;
    }

    if (!isNativeInteractive) {
      event.preventDefault();
      target.click();
    }
  }
}
